import _ from 'lodash';
import moment from 'moment';
import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getSalesStats } from '../../../api/payments.api';
import { getSemesterMonths } from '../../../api/semesters.api';
import useAxios from '../../../hooks/useAxios';
import { getCommonCodeLabel } from '../../../lib/store';
import { IGetSalesStats } from '../../../models/payments.model';
import { IGetSemesterMonths } from '../../../models/semesters.model';
import { RootState } from '../../../store/rootReducer';
import ErrorResponse from '../../ErrorResponse';
import Loader from '../../Loader';

interface IProps {
  semesterCode: number | undefined;
}

const CampusSales: FC<IProps> = ({ semesterCode }) => {
  const { t, i18n } = useTranslation();
  const { serverDate } = useSelector((state: RootState) => state.serverDate);
  const {
    data: res,
    isLoading,
    error,
    execute,
  } = useAxios<IGetSemesterMonths>();
  const {
    data: res2,
    isLoading: isLoading2,
    error: error2,
    execute: execute2,
  } = useAxios<IGetSalesStats>();

  const [data, setData] = useState<any>([]);

  useEffect(() => {
    if (semesterCode) {
      execute(getSemesterMonths(String(semesterCode)));
    }
  }, [semesterCode]);

  useEffect(() => {
    if (res?.data && !isLoading) {
      const currentMonth = moment(serverDate).format('M');
      const monthSeq = res.data.find(
        (month) => String(month.monthName) === currentMonth,
      )?.monthSeq;

      if (semesterCode && monthSeq) {
        execute2(getSalesStats({ semesterCode, monthSeq }));
      }
    }
  }, [res, isLoading]);

  useEffect(() => {
    if (res2 && !isLoading2) {
      const _data: any = [];
      res2.data?.forEach((item) => {
        _data.push({
          campusCode: item.campusCode,
          campusName: item.campusName,
          campusNameEn: item.campusNameEn,
          campusDiv: item.campusDiv,
          sales:
            item.onlineTuition +
            item.shuttleTuition +
            item.tuition +
            item.alexTuition,
        });
      });
      setData(_.sortBy(_data, 'sales').reverse());
    }
  }, [res2, isLoading2]);

  return (
    <>
      {(isLoading || isLoading2) && <Loader />}
      <ErrorResponse error={error} />
      <ErrorResponse error={error2} />

      <div className='comm-table__area'>
        <table>
          <thead>
            <tr>
              <th className="font-weight-bold">
                {t('class.dashboard.column9')}
              </th>
              <th className="font-weight-bold">{t('common.menu.campus')}</th>
              <th className="font-weight-bold">
                {t('class.dashboard.column10')}
              </th>
              <th className="font-weight-bold">
                {t('class.dashboard.column11')}
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((item: any, index: number) => (
              <tr key={index}>
                <td>{data.indexOf(item) + 1}</td>
                <td>{i18n.language === 'ko' ? item.campusName : item.campusNameEn}</td>
                <td>{getCommonCodeLabel('CA0003', item.campusDiv, i18n.language)}</td>
                <td>{item.sales?.toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan={3}>
                {t('class.dashboard.column12')}
              </td>
              <td>
                {data
                  .reduce((acc: number, cur: any) => acc + cur.sales, 0)
                  ?.toLocaleString()}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </>
  );
};

export default CampusSales;
